import { Theme } from "@mui/material/styles";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    height: `calc(100% - ${theme.spacing.spacing28})`,
    alignItems: "flex-start",
  },
  bodyContent: {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  },
  bodyContentLTR: {
    paddingLeft: theme.spacing.spacing6,
  },
  bodyContentRTL: {
    paddingRight: theme.spacing.spacing6,
  },
  content: {
    fontSize: theme.typography.size.xs,
    fontWeight: theme.typography.fontWeightRegular,
    whiteSpace: "pre-line",
  },
  fileRow: {
    display: "flex",
    marginBottom: theme.spacing.spacing7,
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  detailsContainerLTR: {
    marginLeft: theme.spacing.spacing12_5,
  },
  detailsContainerRTL: {
    marginRight: theme.spacing.spacing12_5,
  },
  detailsTitle: {
    display: "flex",
    flexDirection: "column",
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.size.md,
    lineHeight: "20px",
  },
  date: {
    fontSize: theme.typography.size.xs,
    fontWeight: theme.typography.fontWeightRegular,
  },
  approveCheckBoxContainer: {
    margin: `${theme.spacing.spacing12_5} 0 ${theme.spacing.spacing7}`,
    fontSize: theme.typography.size.xs,
    fontWeight: theme.typography.fontWeightRegular,
  },
  checkBoxLTR: {
    padding: `${theme.spacing.spacing4} ${theme.spacing.spacing4} ${theme.spacing.spacing4} 0px!important`,
  },
  checkBoxRTL: {
    padding: `${theme.spacing.spacing4} 0px ${theme.spacing.spacing4} ${theme.spacing.spacing4}!important`,
  },
});
